import { api } from "./api";

export const bulkApi = {
  bulkUpdateUsers: (userIds: string[], updates: { isActive?: boolean; isSuspended?: boolean; role?: string }) => {
    return api.post<{ success: boolean; message: string; data: any }>("/bulk/users/update", {
      userIds,
      updates,
    });
  },

  bulkDeleteUsers: (userIds: string[]) => {
    return api.post<{ success: boolean; message: string }>("/bulk/users/delete", { userIds });
  },

  bulkUpdateCourses: (courseIds: string[], updates: { isFeatured?: boolean; isPublished?: boolean }) => {
    return api.post<{ success: boolean; message: string; data: any }>("/bulk/courses/update", {
      courseIds,
      updates,
    });
  },

  bulkDeleteCourses: (courseIds: string[]) => {
    return api.post<{ success: boolean; message: string }>("/bulk/courses/delete", { courseIds });
  },

  bulkPublishCourses: (courseIds: string[]) => {
    return api.post<{ success: boolean; message: string }>("/bulk/courses/publish", { courseIds });
  },

  bulkUnpublishCourses: (courseIds: string[]) => {
    return api.post<{ success: boolean; message: string }>("/bulk/courses/unpublish", { courseIds });
  },

  bulkEnrollUsers: (userIds: string[], courseId: string) => {
    return api.post<{ success: boolean; message: string }>("/bulk/enrollments", { userIds, courseId });
  },

  bulkSendNotifications: (
    userIds: string[],
    notification: { title: string; message: string; type?: string }
  ) => {
    return api.post<{ success: boolean; message: string }>("/bulk/notifications", { userIds, notification });
  },

  exportUsers: (options?: { format?: string; role?: string; isActive?: boolean }) => {
    const params = new URLSearchParams();
    if (options?.format) params.append("format", options.format);
    if (options?.role) params.append("role", options.role);
    if (options?.isActive !== undefined) params.append("isActive", String(options.isActive));
    const endpoint = `/bulk/users/export${params.toString() ? `?${params.toString()}` : ""}`;
    
    if (options?.format === "csv") {
      console.log("CSV export detected, calling getText");
      return api.getText(endpoint).then(text => ({ success: true, data: text }));
    }
    
    console.log("Calling regular get for export");
    return api.get<{ success: boolean; data: any }>(endpoint);
  },

  exportCourses: (options?: { format?: string; category?: string }) => {
    const params = new URLSearchParams();
    if (options?.format) params.append("format", options.format);
    if (options?.category) params.append("category", options.category);
    const endpoint = `/bulk/courses/export${params.toString() ? `?${params.toString()}` : ""}`;
    
    if (options?.format === "csv") {
      return api.getText(endpoint).then(text => ({ success: true, data: text }));
    }
    
    return api.get<{ success: boolean; data: any }>(endpoint);
  },
};